export default abstract class UndoCommand {
    abstract doUndoAction(): void
}